import * as React from "react";
import Svg, { Path } from "react-native-svg";

export function GiftPointsEarned(props?: any) {
  return (
    <Svg
      width={props?.width || 66}
      height={props?.height || 41}
      viewBox="0 0 66 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        opacity={0.5}
        d="M14.015 5.579C11.55 4.016 7.586 1.092 9.944.9c3.034-.246 3.016 2.854 4.071 4.678zM51.974 35.394c2.466 1.563 6.43 4.486 4.072 4.678-3.035.246-3.017-2.854-4.072-4.678zM51.038 8.117c.8-2.975 2.509-7.805 3.481-5.173 1.252 3.39-1.95 3.755-3.481 5.173zM15.92 34.353c-.799 2.974-2.508 7.805-3.48 5.172-1.253-3.389 1.949-3.755 3.48-5.172zM55.521 13.124c1.124-3.02 7.846-7.504 7.7-4.701-.188 3.607-5.732 4.004-7.7 4.7zM10.468 27.849c-1.124 3.019-7.846 7.504-7.7 4.701.189-3.608 5.732-4.004 7.7-4.701zM11.184 16.377c-2.48-3.23-12.265-6.15-11.047-2.82 1.567 4.29 8.411 2.71 11.047 2.82zM54.805 24.596c2.48 3.229 12.265 6.15 11.047 2.819-1.567-4.288-8.411-2.709-11.047-2.82z"
        fill={props?.color || "#F26924"}
      />
      <Path
        d="M43 12h-2.762A4.487 4.487 0 0033 6.705 4.487 4.487 0 0025.762 12H23a2.002 2.002 0 00-2 2v4a2.002 2.002 0 002 2v10a2.002 2.002 0 002 2h16a2.002 2.002 0 002-2V20a2.002 2.002 0 002-2v-4a2.002 2.002 0 00-2-2zm-9-2.5a2.5 2.5 0 112.5 2.5H34V9.5zM29.5 7A2.503 2.503 0 0132 9.5V12h-2.5a2.5 2.5 0 010-5zM23 14h9v4h-9v-4zm2 6h7v10h-7V20zm16.001 10H34V20h7l.001 10zM34 18v-4h9l.001 4H34z"
        fill={props?.color || "#F26924"}
      />
    </Svg>
  );
}

export default GiftPointsEarned;
